var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Admin" } }, [
    !_vm.ready
      ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
      : _vm._e(),
    _vm._v(" "),
    _vm.ready
      ? _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("p", [
              _vm._v("User Logs (" + _vm._s(_vm.userlogs.length) + ")")
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table", attrs: { width: "100%" } }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.userlogs, function(item, index) {
                  return _c("tr", [
                    _c("td", [
                      _c("span", { staticClass: "badge badge-secondary" }, [
                        _vm._v(_vm._s(item.request.type))
                      ]),
                      _vm._v(
                        "\n            " +
                          _vm._s(item.request.url) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.system.os))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.system.browser))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.system.device))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getDateTime(item.created_at)))])
                  ])
                }),
                0
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Request")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("OS")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Browser")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Device")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Created")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d614df8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d614df8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/UserLog.vue
// module id = null
// module chunks = 